import './Select.scss';
import * as React from 'react';
import classNames from 'classnames';
export type Props = React.DetailedHTMLProps<
  React.SelectHTMLAttributes<HTMLSelectElement>,
  HTMLSelectElement
> & {
  invalid?: boolean;
  className?: string;
  prompt: string;
  options: Array<[string, string]>;
};
export default class Select extends React.Component<Props> {
  static defaultProps = {
    invalid: false,
    options: [],
  };
  node: HTMLSelectElement | undefined | null;
  focus() {
    if (this.node != null) {
      this.node.focus();
    }
  }
  render() {
    const { className, invalid, options, prompt, ...remainingProps } =
      this.props;
    return (
      <select
        ref={(node) => (this.node = node)}
        className={classNames('Select', className, {
          'Select--invalid': invalid,
        })}
        {...remainingProps}
      >
        <option value="" disabled>
          {prompt}
        </option>
        <option value="" disabled>
          --
        </option>
        {options.map((option, index) => (
          <option key={index} value={option[0]}>
            {option[1]}
          </option>
        ))}
      </select>
    );
  }
}
